import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a5bbd45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "withholding px-3 py-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "\n        過去に働いた仕事の源泉徴収票の確認/印刷ができます\n      ", -1))
const _hoisted_3 = {
  key: 0,
  class: "year-list bg-white border border-outline-color px-3 mt-3 round-4"
}
const _hoisted_4 = { class: "text-black text-size-14 text-weight-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      源泉徴収票の発行\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(),
      (_ctx.years.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearWithStatus, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'year' + item.year,
                class: "year-link"
              }, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'WithholdingSlipList', params: { year: item.year } },
                  class: "d-flex justify-content-between align-items-center py-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(item.text), 1),
                    _createTextVNode(),
                    _createElementVNode("div", null, [
                      (item.isFixed)
                        ? (_openBlock(), _createBlock(_component_AppBadge, {
                            key: 0,
                            variant: "info"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("\n                確定済\n              ")
                            ], undefined, true),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(),
                      _createVNode(_component_FeatherIcon, {
                        icon: "chevron-right",
                        class: "text-gray-05"
                      })
                    ])
                  ], undefined, true),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}